import { apiRequest } from './client'
import type {
  SilkCurrentSubscription,
  SilkPaymentChannel,
  SilkPaymentMethod,
  SilkSubscribeBody,
  SilkSubscriptionInfo,
  SilkPaySubscriptionOrderResponse,
  SilkSubscriptionOrder,
  SilkSubscriptionPage,
  SilkSubscriptionPlan,
  SilkUserSubscription,
} from './types'

export const subscriptionApi = {
  info: (params?: { category_code?: string }) =>
    apiRequest<SilkSubscriptionInfo>('/api/v1/subscription/info', {
      query: params,
      auth: false,
    }),

  page: () =>
    apiRequest<SilkSubscriptionPage>('/api/v1/subscription/page', {
      auth: false,
    }),

  plans: (params?: { category_code?: string }) =>
    apiRequest<{ items: SilkSubscriptionPlan[] }>('/api/v1/subscription/plans', {
      query: params,
      auth: false,
    }),

  current: () => apiRequest<SilkCurrentSubscription>('/api/v1/subscription/me'),

  subscribe: (body: SilkSubscribeBody) =>
    apiRequest<SilkUserSubscription>('/api/v1/subscription/subscribe', {
      method: 'POST',
      body,
    }),

  cancel: (body?: { category_code?: string }) =>
    apiRequest<{ ok: boolean }>('/api/v1/subscription/cancel', {
      method: 'POST',
      body,
    }),

  paymentMethods: () =>
    apiRequest<{ methods: SilkPaymentMethod[] }>('/api/v1/subscription/payment-methods'),

  createOrder: (body: { plan_code: string; channel: SilkPaymentChannel }) =>
    apiRequest<SilkSubscriptionOrder>('/api/v1/subscription/orders', {
      method: 'POST',
      body,
    }),

  payOrder: (orderId: string) =>
    apiRequest<SilkPaySubscriptionOrderResponse>(
      `/api/v1/subscription/orders/${encodeURIComponent(orderId)}/pay`,
      { method: 'POST' },
    ),

  getOrder: (orderId: string) =>
    apiRequest<SilkSubscriptionOrder>(
      `/api/v1/subscription/orders/${encodeURIComponent(orderId)}`,
    ),
}
